import styled from 'styled-components';

import { ButtonIcon } from '@pkg/components/Sections/Profile/Buttons';

export const StyledYatButton = styled(ButtonIcon)<{ $canShow: boolean }>`
    &&& {
        position: absolute;
        top: 10px;
        right: 10px;
        opacity: ${({ $canShow }) => ($canShow ? 1 : 0)};
        transition: opacity ${({ theme }) => theme.transitions.speeds.normal}s;

        &:hover,
        &:focus {
            opacity: 1;
        }
    }
`;
